export default __webpack_public_path__ + "static/te_medium_2-655aba2035449aacb7faaab8e5c2d34b.png";